import React from "react";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Checkbox, MenuItem, TextField } from "@mui/material";
import addProdotto from "../services/addProdotto";
import Cookies from "universal-cookie";
import getProdotto from "../services/getProdotto";
import LoadingButton from '@mui/lab/LoadingButton';
import editProdotto from "../services/editProdotto";
import _default from "../themes/default";
import { Stack } from "@mui/system";
import MultiSelectSearch from "./MultiSelectSearch";
import addReminder from "../services/addReminder";

const style = {
    zIndex: 999,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    borderRadius: 2,
    flex: 1,
    bgcolor: 'white',
    boxShadow: 24,
    p: 4,
};

let cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });
let userType = cookies.get('userType', { path: '/' });

export default class MyModalProdotti extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            id: '',
            nome: '',
            codice: '',
            prezzo: '',
            costo: '',
            fornitore: [],
            giacenzaMax: '',
            giacenzaMin: '',
            cumulativo: false,
            um: '',
            quantita_um: '',
            calcolo_um: '',
        }
    }

    async componentDidMount() {
        cookies = new Cookies();
        username = cookies.get('username', { path: '/' });
        token = cookies.get('token', { path: '/' });
        userType = cookies.get('userType', { path: '/' });

        let current = this.props.prodotto;
        if (current) {
            let prodotto = await getProdotto(username, token, current);
            let fornitori = JSON.parse(prodotto.id_fornitore);
            let selectedFornitori = fornitori.map((f) => {
                return this.props.fornitori.find((fornitore) => fornitore.id === f);
            });
            this.setState({
                id: current,
                nome: prodotto.nome,
                codice: prodotto.codice,
                prezzo: prodotto.prezzo,
                costo: prodotto.costo,
                fornitore: JSON.parse(prodotto.id_fornitore),
                giacenzaMax: prodotto.giacenza_max,
                consegna_max: prodotto.consegna_max,
                giacenzaMin: prodotto.giacenza_min,
                selectedFornitori,
                cumulativo: prodotto.cumulativo === '1',
                um: prodotto.unita_di_misura ? prodotto.unita_di_misura : '',
                quantita_um: prodotto.quantita_per_um ? prodotto.quantita_per_um : '',
                calcolo_um: prodotto.calcolo_um_prezzo ? prodotto.calcolo_um_prezzo : '',
            });
        } else {
            this.setState({})
        }
    }


    componentDidUpdate(prevProps, prevState) {
        if ((prevState.um !== this.state.um || prevState.quantita_um !== this.state.quantita_um) && this.state.cumulativo) {
            if (this.state.um.trim && this.state.quantita_um !== '') {
                let calcolo_um = (parseFloat(this.state.prezzo) / parseFloat(this.state.quantita_um)).toFixed(2);
                this.setState({ calcolo_um });
            }
        }
        if(prevState.cumulativo && !this.state.cumulativo) {
            this.setState({um: '', quantita_um: '', calcolo_um: ''});
        }
    }


    async save() {
        let cookies = new Cookies();
        let current = cookies.get('prodotto', { path: '/' });
        var token = cookies.get('token', { path: '/' });
        var username = cookies.get('username', { path: '/' });
        var duplicateCodeErrorMessage = "Il codice inserito risulta già inserito in un altro prodotto";
        var genericeErrorMessage = "Errore nella modifica del prodotto";

        if (this.state.nome.trim() !== '' && this.state.codice.trim() !== '' && this.state.prezzo.trim() !== '' && this.state.costo.trim() !== '' && this.state.giacenzaMax.trim() !== '' && this.state.giacenzaMin.trim() !== '') {

            if (this.state.fornitore.length === 0 || this.state.fornitore === null || this.state.fornitore === undefined) {
                alert('Selezionare almeno un fornitore');
                return;
            }


            if (parseInt(this.state.giacenzaMax) < parseInt(this.state.giacenzaMin)) {
                alert('La giacenza massima deve essere maggiore della giacenza minima');
                return;
            }

            if (!this.state.consegna_max) return alert('Inserire la consegna massima');

            if(this.state.cumulativo) {
                if(this.state.um === '') return alert('Inserire l\'unità di misura');
                if(this.state.quantita_um === '') return alert('Inserire la quantità per unità di misura');
            }

            this.setState({ isLoading: true });

            if (!current) {
                let res = await addProdotto(username, token, this.state);
                if (res.result === 'ok') {
                    if(userType === '4') {
                        addReminder(username, token, 'Aggiunto prodotto ' + this.state.nome, 'amministrazione', 'prodotto', res.id_prodotto);
                    }
                    this.props.onReload();
                    this.close();
                    return;
                }
                this.setState({ isLoading: false });
                res.errore === duplicateCodeErrorMessage ? alert(res.errore) : alert(genericeErrorMessage);
            } else {
                let res = await editProdotto(username, token, this.state);
                if (res.result === 'ok') {
                    this.props.onReload();
                    this.close();
                    return;
                }
                this.setState({ isLoading: false });
                res.errore === duplicateCodeErrorMessage ? alert(res.errore) : alert(genericeErrorMessage);
            }
        } else {
            alert('Compilare correttamente tutti i campi');
        }
    }

    handleChangeFornitori(fornitori) {
        let fornitore = fornitori.map((f) => f.id);
        this.setState({ fornitore, selectedFornitori: fornitori });
    }

    close() {
        this.props.onClose();
    }

    render() {
        return (    
            <Modal
                open={this.props.modal.show}
                onClose={() => this.close()}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Stack direction={'column'} spacing={2} sx={{ flex: 1 }}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            {this.props.title}
                        </Typography>
                        <Stack direction={'row'} spacing={2} sx={{ flex: 1 }}>
                            <TextField fullWidth inputProps={{ readOnly: (!this.props.isUserType || userType === '2') }} label="Nome prodotto" variant="outlined" InputLabelProps={{ shrink: this.state.nome }} value={this.state.nome} onChange={(e) => this.setState({ nome: e.target.value })} />
                            <TextField inputProps={{ readOnly: (!this.props.isUserType || userType === '2') }} label="Codice prodotto" variant="outlined" InputLabelProps={{ shrink: this.state.codice }} value={this.state.codice} onChange={(e) => this.setState({ codice: e.target.value })} />
                        </Stack>
                        <Stack direction={'row'} spacing={2} sx={{ flex: 1 }}>
                            <TextField fullWidth label="Prezzo prodotto" type="number" InputLabelProps={{ shrink: this.state.prezzo }} inputProps={{ min: 0, readOnly: (!this.props.isUserType || userType === '2') }} variant="outlined" value={this.state.prezzo} onChange={(e) => this.setState({ prezzo: e.target.value })} />
                            <TextField fullWidth label="Costo prodotto" type="number" InputLabelProps={{ shrink: this.state.costo }} inputProps={{ min: 0, readOnly: (!this.props.isUserType || userType === '2') }} variant="outlined" value={this.state.costo} onChange={(e) => this.setState({ costo: e.target.value })} />
                            <TextField fullWidth label="Consegna Massima" type="number" InputLabelProps={{ shrink: this.state.consegna_max }} inputProps={{ min: 0, readOnly: (!this.props.isUserType || userType === '2') }} variant="outlined" value={this.state.consegna_max} onChange={(e) => this.setState({ consegna_max: e.target.value })} />
                        </Stack>
                        <Stack direction={'row'} spacing={2} sx={{ flex: 1, alignItems: 'center' }}>
                        <Checkbox disabled={!this.props.isUserType || userType === '2'} checked={this.state.cumulativo} onChange={(e) => this.setState({ cumulativo: e.target.checked })} /> Prodotto Cumulativo
                        </Stack>

                        {
                            this.state.cumulativo && <Stack direction={'row'} spacing={2} sx={{ flex: 1 }}>
                                <TextField select fullWidth label="Unità di misura" inputProps={{ readOnly: (!this.props.isUserType || userType === '2') }} variant="outlined" value={this.state.um} onChange={(e) => this.setState({ um: e.target.value })}>
                                    <MenuItem value={'pezzo'}>Pezzo</MenuItem>
                                    <MenuItem value={'scatola'}>Scatola</MenuItem>
                                    <MenuItem value={'bancale'}>Bancale</MenuItem>
                                </TextField>
                                <TextField fullWidth label="Quantità per unità di misura" type="number" InputLabelProps={{ shrink: this.state.quantita_um }} inputProps={{ min: 0, readOnly: (!this.props.isUserType || userType === '2') }} variant="outlined" value={this.state.quantita_um} onChange={(e) => this.setState({ quantita_um: e.target.value })} />
                                <TextField fullWidth label="Calcolo per euro/pezzo" type="number" InputLabelProps={{ shrink: this.state.calcolo_um }} inputProps={{ min: 0, readOnly:true}} variant="outlined" value={this.state.calcolo_um} />
                            </Stack>
                        }

                        <MultiSelectSearch readOnly={!this.props.isUserType || userType === '2'} labelKey={'ragione_sociale'} optionsArray={this.props.fornitori} label='Fornitori' selectedValues={this.state.selectedFornitori} onSelected={(e) => { this.handleChangeFornitori(e) }} />

                        <Stack direction={'row'} spacing={2} sx={{ flex: 1 }}>
                            <TextField fullWidth label="Giacenza Min prodotto" inputProps={{ min: 0, readOnly: (!this.props.isUserType || userType === '2') }} type="number" InputLabelProps={{ shrink: this.state.giacenzaMin }} variant="outlined" value={this.state.giacenzaMin} onChange={(e) => this.setState({ giacenzaMin: e.target.value })} />
                            <TextField fullWidth label="Giacenza Max prodotto" inputProps={{ min: 0, readOnly: (!this.props.isUserType || userType === '2') }} type="number" InputLabelProps={{ shrink: this.state.giacenzaMax }} variant="outlined" value={this.state.giacenzaMax} onChange={(e) => this.setState({ giacenzaMax: e.target.value })} />
                        </Stack>
                        {
                            (this.props.isUserType && userType !== '2') && <LoadingButton fullWidth sx={{ flex: 1, minHeight: 50 }} style={{ backgroundColor: _default.palette.primary.main }} variant='contained' loading={this.state.isLoading} onClick={() => this.save()}>{this.props.prodotto ? "Modifica" : "salva"}</LoadingButton>
                        }
                    </Stack>
                </Box>
            </Modal>
        )
    }
}